import React from 'react';

const Footer = () => {
    return (
        <footer className="app-footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 text-center">
                        <small className="text-muted">
                            © {new Date().getFullYear()} Saral Asset Management System. All rights reserved.
                        </small>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;